export default {
  buttonGradientStart: '#B433B5',
  buttonGradientEnd: '#8c288d',
  primary: '#B433B5',
  foreground: '#ffffff',
  background: '#f8f9fb',
  text: '#222222',
  accent: '#ababab',
  error: '#F32A0F',
  success: '#42C87C',
}



// WEBPACK FOOTER //
// ./src/components/styles/colors.js